import {
  InfoCircle,
} from "react-bootstrap-icons";
import { Row, Col, Image, Stack } from "react-bootstrap";
import { IoCarSport } from "react-icons/io5";
import { HiLocationMarker } from "react-icons/hi";
import { BsFillCalendar2DateFill, BsShieldFillCheck } from "react-icons/bs";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { TbCreditCard } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

const SummaryPanel = ({
  driver,
  drivers = [],
  vehicle,
  vehicles = [],
  location,
  bookingDates,
  addOnServices,
  bookingType,
  selectedSlotDetail,
  selectedPayment,
  isExtendParking,
  setSelectedPayment,
  handlePayNowClick,
  handleCancelReservation,
  numberOfSpots,
  bookingMode,
}) => {



  // ================================
  // PRICING LOGIC (from BookingReceipt)
  // ================================

  const safeAddOns = Array.isArray(addOnServices) ? addOnServices : [];
  // console.log("bookingDates)
  const numberOfUnits = bookingType === "MONTHLY_SUBSCRIPTION" ? 1 : (bookingDates?.length || 0);

  const freeAddOnServices = [];
  const paidSelectedAddonServices = [];
  const carouselId = "driverCarouselMulti";
  const vehicleCarouselId = "vehicleCarousel";
  const finalDrivers = Array.isArray(drivers) && drivers.length > 0
    ? drivers
    : driver
      ? [driver]
      : [];

  const finalVehicles = Array.isArray(vehicle) ? vehicle : vehicle ? [vehicle] : [];


  for (let x of safeAddOns) {
    if (x?.isFree) {
      freeAddOnServices.push(x);
    } else if (!x?.isFree && x?.isSelected) {
      switch (bookingType) {
        case "DAY":
          paidSelectedAddonServices.push({
            name: x?.name,
            totalAmount: x?.dayPrice?.price * numberOfUnits,
          });
          break;
        case "WEEKLY":
          paidSelectedAddonServices.push({
            name: x?.name,
            totalAmount: x?.weeklyPrice?.price * numberOfUnits,
          });
          break;
        case "MONTHLY":
          paidSelectedAddonServices.push({
            name: x?.name,
            totalAmount: x?.monthlyPrice?.price * numberOfUnits,
          });
          break;
        case "MONTHLY_SUBSCRIPTION":
          paidSelectedAddonServices.push({
            name: x?.name,
            totalAmount: x?.monthlySubscriptionPrice?.price * numberOfUnits,
          });
          break;
        default:
          console.warn("Unknown booking type:", bookingType);
      }
    }
  }


  // =======================================
  // FUNCTION: Get parking price details
  // =======================================

  const getParkingPrice = (locationDetail, bookingType, units) => {
    let parkingDetail = { totalAmount: 0, preferredSlotCharge: 0 };
    if (
      locationDetail &&
      Array.isArray(locationDetail.location_price) &&
      locationDetail.location_price.length > 0 &&
      locationDetail.location_price[0]?.isFree
    ) {
      return parkingDetail;
    }
    switch (bookingType) {
      case "DAY":
        parkingDetail = {
          totalAmount: locationDetail?.location_price?.[0]?.dayPrice?.overridePrice * units,
          preferredSlotCharge: locationDetail?.preferred_slot_charge?.price,
        };
        break;
      case "WEEKLY":
        parkingDetail = {
          totalAmount: locationDetail?.location_price?.[0]?.weeklyPrice?.overridePrice * units,
          preferredSlotCharge: locationDetail?.preferred_slot_charge?.price,
        };
        break;
      case "MONTHLY":
        parkingDetail = {
          totalAmount: locationDetail?.location_price?.[0]?.monthlyPrice?.overridePrice * units,
          preferredSlotCharge: locationDetail?.preferred_slot_charge?.price,
        };
        break;
      case "MONTHLY_SUBSCRIPTION":
        parkingDetail = {
          totalAmount: locationDetail?.location_price?.[0]?.monthlySubscriptionPrice?.overridePrice * units,
          preferredSlotCharge: locationDetail?.preferred_slot_charge?.price,
        };
        break;
      default:
        console.warn("Unknown booking type:", bookingType);
    }

    return parkingDetail;
  };


  // Get parking price details
  const slotChargeDetail = getParkingPrice(location, bookingType, numberOfUnits);


  // =======================================
  // FUNCTION: Calculate subtotal amount
  // =======================================

  const calculateSubtotal = () => {
    let subtotal = 0;

    subtotal += slotChargeDetail.totalAmount || 0;

    if (selectedSlotDetail?.isPreferred) {
      subtotal += slotChargeDetail.preferredSlotCharge || 0;
    }

    for (let service of paidSelectedAddonServices) {
      subtotal += service.totalAmount || 0;
    }

    return subtotal;
  };

  // =======================================
  // FUNCTION: Calculate consecutives date for booking type day
  // =======================================
  const groupConsecutiveDates = (dates = []) => {

    if (!dates.length) return [];

    // SORT DATES
    const sorted = [...dates].sort(
      (a, b) =>
        new Date(a.startDateTime) - new Date(b.startDateTime)
    );

    const groups = [];

    let currentGroup = [sorted[0]];

    for (let i = 1; i < sorted.length; i++) {

      const prevDate = moment(sorted[i - 1].startDateTime)
        .startOf("day");

      const currentDate = moment(sorted[i].startDateTime)
        .startOf("day");

      // CHECK IF NEXT DAY
      const diff = currentDate.diff(prevDate, "days");

      if (diff === 1) {

        currentGroup.push(sorted[i]);

      } else {

        groups.push(currentGroup);

        currentGroup = [sorted[i]];
      }
    }

    groups.push(currentGroup);

    // CREATE DISPLAY RANGE
    return groups.map((group) => {

      const start = moment(group[0].startDateTime);

      // LAST DATE + 1 DAY
      const end = moment(group[group.length - 1].startDateTime)
        .add(1, "day")
        .hour(23)
        .minute(59)
        .second(59);

      return {
        startDateTime: start.toISOString(),
        endDateTime: end.toISOString(),
      };
    });
  };




  return (
    <aside className="rb-summary  vh-100 overflow-scroll">

      <h4 className="title mb-2">Reservation Summary</h4>

      {/* DRIVER */}
      {finalDrivers.length > 0 && (
        <div className="summary-card">

          {finalDrivers.length > 1 && (
              <p className="mb-2 text-success small">
                {finalDrivers.length} drivers selected
              </p> )}

              <div id={carouselId} className="carousel slide dark" data-bs-ride="false">

                <div className="carousel-inner">
                  {finalDrivers.map((d, index) => (
                    <div
                      key={d._id}
                      className={`carousel-item ${index === 0 ? "active" : ""}`}
                    >
                      <Row className="align-items-center">
                        <Col xs="auto">
                          <img
                            src={d.profileImage || "assets/images/placeholder.png"}
                            width={50}
                            height={50}
                            alt="driver"
                            className="border rounded"
                          />
                        </Col>
                        <Col>
                          <strong>{d?.userName || d?.name || ""}</strong>
                          <p>{d?.email}</p>
                          <p>{d?.phoneNumber || d?.phone}</p>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>

                {/* Carousel indicators (dots) */}
                <div className="carousel-indicators position-static m-0">
                  {finalDrivers?.length > 1 && finalDrivers.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target={`#${carouselId}`}
                      data-bs-slide-to={index}
                      className={index === 0 ? "active" : ""}
                    />
                  ))}
                </div>

              </div>
        </div>
      )}

      {/* VEHICLE */}
      {finalVehicles.length > 0 && (
        <div className="summary-card">

          {finalVehicles.length > 1 && (
            <p className="mb-2 text-success small">
              {finalVehicles.length} vehicles selected
            </p>)}

              {/* Carousel wrapper */}
              <div id={vehicleCarouselId} className="carousel slide" data-bs-ride="false">

                <div className="carousel-inner">
                  {finalVehicles.map((v, index) => (
                    <div
                      key={v._id}
                      // Required for bootstrap carousel to initialize correctly
                      className={`carousel-item ${index === 0 ? "active" : ""}`}
                    >
                      <Row className="align-items-center">
                        <Col xs="auto">
                          <div className="icon-box">
                            <IoCarSport size={34} color="#2563eb" />
                          </div>
                        </Col>
                        <Col>
                          <strong>{v.vehicleName || v.truck}</strong>
                          <p>{v.licensePlate || v.plate}</p>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>

                {/* Indicator dots */}
                <div className="carousel-indicators position-static m-0">
                  {finalVehicles?.length > 1 &&finalVehicles.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target={`#${vehicleCarouselId}`}
                      data-bs-slide-to={index}
                      className={index === 0 ? "active" : ""}
                    />
                  ))}
                </div>

              </div>
        </div>
      )}

      {/* LOCATION */}
      {location?._id &&
        <div className="summary-card">
          <div className="d-flex justify-content-between">
            {/* <span className="label">Location</span> */}
          </div>
          <Row className="align-items-start mt-0">
            <Col xs="auto">
              {location?.locationImage
                ? <Image src={location?.locationImage} className="object-fit-fill" thumbnail width={50} height={50} />
                : <div className="icon-box"><HiLocationMarker size={34} color="#2563eb" /></div>}
            </Col>
            <Col>
              <strong>{location?.locationName}</strong>
              <p>{location?.locationAddress}</p>
              <span className="spots">{location?.avaliableSlots} Spots Left</span>
            </Col>
          </Row>
        </div>}


      {/* DATE & TIME */}
      {bookingDates?.length > 0 && (
        <div className="summary-card " >
          <div className="d-flex justify-content-between">
            {/* <span className="label">Date & Time</span> */}
          </div>

          <div className='px-3' style={{ maxHeight: "180px", overflowY: "auto" }}>
            {bookingType === "DAY" && !isExtendParking

              // DAY — group consecutive dates → show as one range
              ? groupConsecutiveDates(bookingDates).map((group, idx) => (
                <Row key={idx} className="align-items-start mt-2">
                  <Col xs="auto">
                    <div className="icon-box">
                      <BsFillCalendar2DateFill size={30} color="#2563eb" />
                    </div>
                  </Col>
                  <Col>
                    <div className="d-flex justify-content-between">
                      <small className="mb-0 fw-semibold small text-secondary text-nowrap">
                        {moment(group.startDateTime)
                          .tz(location?.location_timezone || moment.tz.guess())
                          .format("DD MMM YYYY hh:mm A")}
                      </small>
                    </div>
                    <div className="d-flex justify-content-between mt-1">
                      <small className="mb-0 fw-semibold small text-secondary text-nowrap">
                        {moment(group.endDateTime)
                          // .tz(location?.location_timezone || moment.tz.guess())
                          .format("DD MMM YYYY hh:mm A")}
                      </small>
                    </div>
                  </Col>
                </Row>
              ))

              // WEEKLY / MONTHLY / MONTHLY_SUBSCRIPTION
              : bookingDates.map((d, idx) => (
                <Row key={idx} className="align-items-start mt-2">
                  <Col xs="auto">
                    <div className="icon-box">
                      <BsFillCalendar2DateFill size={30} color="#2563eb" />
                    </div>
                  </Col>
                  <Col>
                    <h6 className="mb-0 fw-semibold small text-secondary text-nowrap">
                      {moment.utc(d?.startDateTime)
                        .tz(location?.location_timezone || moment.tz.guess())
                        .format("DD MMM YYYY hh:mm A")}
                    </h6>
                    <h6 className="mb-0 fw-semibold small text-secondary text-nowrap mt-1">
                      {moment.utc(d?.endDateTime)
                        .tz(location?.location_timezone || moment.tz.guess())
                        .format("DD MMM YYYY hh:mm A")}
                    </h6>
                  </Col>
                </Row>
              ))
            }
          </div>
        </div>
      )}

      {/* PRICING */}
      {(bookingDates?.length > 0 && location?._id && (bookingMode==="single" ? finalVehicles.length > 0  : true)) &&
        <div>
          <div className="pricing">
            <h6 className="fw-bold">Pricing Details</h6>

            <div className="mt-3 d-flex flex-column gap-2">

              {/* Parking base price */}
              {slotChargeDetail.totalAmount > 0 && (
                <Row>
                  <Col className="small">Parking x {numberOfUnits || ""}</Col>
                  <Col xs="auto"><strong className="small">${slotChargeDetail.totalAmount}</strong></Col>
                </Row>
              )}


              {/* Preferred slot charge */}
              {selectedSlotDetail?.isPreferred && slotChargeDetail.preferredSlotCharge > 0 && (
                <Row>
                  <Col className="small">Preferred Slot Charge</Col>
                  <Col xs="auto"><strong className="small">${slotChargeDetail.preferredSlotCharge}</strong></Col>
                </Row>
              )}

              {/* Free add-ons */}
              {freeAddOnServices.map((service, i) => (
                <Row key={i}>
                  <Col className="small">{service?.name}</Col>
                  <Col xs="auto" className="text-success small fw-bold">Free</Col>
                </Row>
              ))}

              {/* Paid add-ons */}
              {paidSelectedAddonServices.map((service, i) => (
                <Row key={i}>
                  <Col className="small">{service?.name} x {numberOfUnits}</Col>
                  <Col xs="auto"><strong className="small">${service?.totalAmount}</strong></Col>
                </Row>
              ))}

              {bookingMode === "single" ? (
                <Row className="total">
                  <Col className="small fw-bold">Total (USD)</Col>
                  <Col xs="auto"><small className="small text-primary fw-bold">${calculateSubtotal().toFixed(2)}</small></Col>
                </Row>
              ) : (
                <>
                  <Row className="total border-top">
                    <Col className="small fw-semibold">SubTotal (USD)</Col>
                    <Col xs="auto"><small className="small fw-semibold">${calculateSubtotal().toFixed(2)}</small></Col>
                  </Row>
                  <Row>
                    <Col className="small ">Number of Spots</Col>
                    <Col xs="auto"><small className="small fw-bold">{numberOfSpots}</small></Col>
                    </Row>
                    
                    <Row className="total border-top ">
                  <Col className="small fw-bold">Total (USD)</Col>
                  <Col xs="auto"><small className="small text-primary fw-bold">${(calculateSubtotal() * numberOfSpots ).toFixed(2)}</small></Col>
                </Row>
                </>
              )}
            </div>
          </div>

          {/* SAVING */}
          {/* {bookingType === "MONTHLY_SUBSCRIPTION" && <div className="saving-box">
            You're saving $12.00 with your membership
          </div>} */}

          {/* SECURE */}
          <div className="secure p-2 d-flex gap-2">
            <BsShieldFillCheck size={34} color="#2563eb" className="mt-1"/>
            <div>
              <strong>Secure Reservation</strong>
              <p className="small mb-0">Your reservation is secure and encrypted.</p>
            </div>
          </div>

          {/* Payment Method */}
          <div className="mt-3 d-flex flex-column gap-2">

            {/* Pay Online */}
            <button
              type="button"
              onClick={() => {
                setSelectedPayment("STRIPE");
                handlePayNowClick(calculateSubtotal() === 0, "STRIPE");
              }}
              className={`d-flex align-items-center gap-3 border-dark border ${selectedPayment === "STRIPE" ? 'bg-primary text-white' : ""} rounded-2 p-2 cursor-pointer user-select-none w-100`}
              style={{ background: selectedPayment === "STRIPE" ? undefined : "transparent" }}
            >
              <div className="d-flex align-items-center justify-content-between w-100 gap-2">
                <div className="d-flex">
                  <TbCreditCard size={25} className="me-2" />
                  <strong>All Cards, ACH</strong>
                </div>
                <IoIosArrowForward />
              </div>
            </button>

            {(() => {
              const type = bookingType;
              const rs = location?.roadSync;

              if (!rs) return null;

              const isRoadSyncEnabled =
                (type === "DAY" && rs.dailyPlanEnabled) ||
                (type === "WEEKLY" && rs.weeklyPlanEnabled) ||
                (type === "MONTHLY" && rs.monthlyPlanEnabled) ||
                (type === "MONTHLY_SUBSCRIPTION" && rs.subscriptionPlanEnabled);

              if (!isRoadSyncEnabled) return null;

              return (
                <>
                  {/* EFS / Fleet Card */}
                  {bookingType !== "MONTHLY_SUBSCRIPTION" && (
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedPayment("ROAD_SYNC");
                        handlePayNowClick(calculateSubtotal() === 0, "ROAD_SYNC");
                      }}
                      className={`d-flex align-items-center gap-3 border-dark border ${selectedPayment === "ROAD_SYNC" ? 'bg-primary text-white' : ""} rounded-2 p-2 cursor-pointer user-select-none w-100`}
                      style={{ background: selectedPayment === "ROAD_SYNC" ? undefined : "transparent" }}
                    >
                      <div className="d-flex align-items-center justify-content-between w-100 gap-2">
                        <div className="d-flex">
                          <Image src="assets/images/efs_logo.png" width={30} height={30} className="object-fit-fill me-2" />
                          <strong>Pay with EFS</strong>
                        </div>
                        <IoIosArrowForward />
                      </div>
                    </button>
                  )}
                </>
              );
            })()}

          </div>

          {/* BUTTONS */}
          {/* <button
            className="confirm"
            onClick={() => handlePayNowClick(calculateSubtotal() === 0, selectedPayment)}
            disabled={selectedPayment ? false : true}
          >
            {calculateSubtotal() === 0 ? "Confirm & Reserve Spot" : " Reserve Spot & Pay"}
          </button> */}
          <button className="cancel" onClick={handleCancelReservation}>Cancel Reservation</button>

          {/* INFO */}
          {/* <div className="info-box mt-3">
            <div className="fw-bold">
              <InfoCircle /> Important Information
            </div>
            <ul className="mb-0">
              <li>Cancellations within 1 hour may include a fee.</li>
            </ul>
          </div> */}

        </div>
      }

    </aside>
  );
}

export default React.memo(SummaryPanel);
